import { NextPageContext } from 'next';
import { GondolaHead } from 'components/GondolaHead/GondolaHead';
import { redirectTo404 } from 'lib/constants';
import { BlogPost } from 'lib/types';
import { BlogPostList } from 'components/Blog/BlogPostList';
import { userIsAdmin, serialize } from 'lib/helpers';
import { notify } from 'lib/utils/honeybadgerUtils';
import { BlogService } from 'server/api/services/blog';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';
import { useRouter } from 'next/router';
import { getCurrentUserFromContext } from 'server/api/services/auth';

export const getServerSideProps = async (context: NextPageContext) => {
  const { query } = context;
  const currentUser = await getCurrentUserFromContext(context);

  if (currentUser) {
    return {
      props: {
        posts: serialize([]),
        meta: serialize(undefined),
      },
    };
  }

  try {
    const blogService = new BlogService();
    const blogPosts = currentUser ? null : await blogService.fetchAllPosts({}, 8);

    if (!blogPosts?.data?.length && !currentUser) {
      return redirectTo404;
    }

    return {
      props: {
        posts: serialize(blogPosts?.data),
        meta: serialize(blogPosts?.meta),
      },
    };
  } catch (err: any) {
    notify(err, 'pages/blog', {
      query,
    });
    return redirectTo404;
  }
};

interface Props {
  posts?: BlogPost[];
  meta?: any;
}

const BlogPage = ({ posts, meta }: Props) => {
  const currentUser = useCurrentUser();
  const API = useApi();
  const router = useRouter();

  const handleClick = async () => {
    await API.refreshBlogPosts();
    router.push(
      {
        pathname: router.pathname,
      },
    );
  };

  return (
    <>
      <GondolaHead
        title="Gondola Blog"
        description="Learn about creators and product announcements on the Gondola blog"
        url="https://gondola.cc/blog"
      />
      <div className="max-w-screen-xl mx-auto px-6 md:py-10">
        <h1 className="text-3xl font-semibold mb-6">
          Gondola Blog
          {userIsAdmin(currentUser) && <button type="button" className="btn-primary ml-5" onClick={() => handleClick()}>Update</button>}
        </h1>
        <BlogPostList blogPosts={posts} blogMeta={meta} />
      </div>
    </>
  );
};

export default BlogPage;
